import Browser from "../Browser";

function getPlaceDetailsClientSide(placeId, google) {
  return new Promise((resolve, reject) => {
    const service = new google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({
      placeId,
      fields: ['address_components', 'geometry.location', 'formatted_address'],
    }, (result, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        reject(status);
      } else {
        resolve(result);
      }
    });
  });
}

async function getPlaceDetailsServerSide(placeId, coreApiClientBase) {
  const response = await coreApiClientBase.get(`/places/${placeId}`);
  return response.data;
}

export function getPlaceDetails({ placeId, google, coreApiClientBase }) {
  if (Browser.isIe11()) {
    return getPlaceDetailsServerSide(placeId, coreApiClientBase);
  }
  return getPlaceDetailsClientSide(placeId, google);
}
